var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { InteractionHandler } from "../../modules/interaction/Interactions";
import { SendMessagesAction, SendDelayedMessagesAction, ConditionalSendMessagesAction, SendMessageCondition, SendMessagesAfterConfirmationAction, AskOkMessage, RequestUserConfirmationRequestMessage } from "flavr-common";
/**
 * This class is responsible for handling SendMessagesActions,
 * SendDelayedMessagesActions and SendMessagesAfterConfirmationAction.
 * This currently only lives in the UserInterfaceModule.
 */
export class SendMessagesInteractionHandler extends InteractionHandler {
    constructor(locationHref) {
        super(SendMessagesAction.typestatic, [], [
            SendMessagesAction.typestatic,
            SendDelayedMessagesAction.typestatic,
            ConditionalSendMessagesAction.typestatic,
            SendMessagesAfterConfirmationAction.typestatic
        ], []);
        this.isOperator = locationHref.includes("operator");
    }
    getActionDescription(params) {
        var _a;
        if (SendMessagesAction.is(params)) {
            return (_a = params.description) !== null && _a !== void 0 ? _a : "";
        }
        return "";
    }
    performAction(action) {
        return __awaiter(this, void 0, void 0, function* () {
            if (SendMessagesAction.is(action)) {
                this.handleSendMessagesAction(action);
            }
            else if (ConditionalSendMessagesAction.is(action)) {
                this.handleConditionalSendMessagesAction(action);
            }
            else if (SendDelayedMessagesAction.is(action)) {
                this.handleSendDelayedMessagesAction(action);
            }
            else if (SendMessagesAfterConfirmationAction.is(action)) {
                yield this.handleSendMessagesAfterConfirmationAction(action);
            }
        });
    }
    handleSendMessagesAction(action) {
        this.send(action.messages);
    }
    handleConditionalSendMessagesAction(action) {
        if (this.testCondition(action.condition)) {
            this.send(action.messages);
        }
    }
    handleSendDelayedMessagesAction(action) {
        setTimeout(() => {
            this.send(action.messages);
        }, action.delay);
    }
    handleSendMessagesAfterConfirmationAction(action) {
        return __awaiter(this, void 0, void 0, function* () {
            const answer = yield this.connection.askByMessageType(new RequestUserConfirmationRequestMessage(action.confirmationText), AskOkMessage);
            if (answer && answer.result) {
                this.send(action.messages);
            }
        });
    }
    send(messages) {
        if (messages.length === 1) {
            this.connection.send(messages[0]);
        }
        else {
            this.connection.sendMultiple(messages);
        }
    }
    testCondition(condition) {
        switch (condition) {
            case SendMessageCondition.IsOperator:
                return this.isOperator;
            default:
                return false;
        }
    }
}
